import React from "react";
import Table from "../../components/UI/Table/Table";
import styles from "./EstadoDocumentos.module.scss";
import Button from "../../components/UI/Button/Button";
import {DocumentosUtils} from "../../util/DocumentosUtils";

const EstadoDocumentosForm = (
  {
    docsAfiliado,
    docsEmpleador,
    docsApoderado,
    docsBeneficiario,
    docsReclamante,
    docsCurador,
    formatos,
    docsBeneficiariosPropietarios,
    docsReclamantesPropietarios,
    docsCuradoresPropietarios,
    docsApoderadosPropietarios,
    docsEmpleadoresPropietarios,
    generarFilaDocumento,
    handleSubmit,
    values,
    loader,
    disabled,
    form,
    totalDocsAfiliado,
    pendingDocsAfiliado,
    totalDocsEmpleador,
    pendingDocsEmpleador,
    totalDocsApoderado,
    pendingDocsApoderado,
    totalFormatos,
    pendingFormatos,
    totalDocsBeneficiario,
    pendingDocsBeneficiario,
    totalDocsReclamante,
    pendingDocsReclamante,
    totalDocsCurador,
    pendingDocsCurador,
    handleGoBack,
    showButton,
    showAlert
  }) => {

    return (

    <>
      <form onSubmit={handleSubmit}>

        {docsAfiliado.length > 0 &&
        <Table id="edDocsAfiliadoTbl"
               title="Documentos del Afiliado"
               totalDocs={totalDocsAfiliado}
               pendingDocs={pendingDocsAfiliado}>
          {docsAfiliado.map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
        </Table>
        }

        {(docsEmpleador.length > 0 && docsEmpleadoresPropietarios.length > 0) &&
        docsEmpleadoresPropietarios.map(docOwner =>
          <Table key={docOwner.id}
                 id={"edDocsEmpleadorTbl" + docOwner.id}
                 title={"Documentos del Empleador " +
                 DocumentosUtils.generarNombrePropietario(docOwner.propietario)}
                 totalDocs={generarTotalDocs(docOwner, totalDocsEmpleador)}
                 pendingDocs={
                   (generarTotalDocs(docOwner, totalDocsEmpleador) -
                     generarTotalDocs(docOwner, pendingDocsEmpleador))}>
            {docsEmpleador
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </Table>
            )}

        {(docsBeneficiario.length > 0 && docsBeneficiariosPropietarios.length > 0) &&
        docsBeneficiariosPropietarios.map(docOwner =>
          <Table key={docOwner.id}
                 id={"edDocsBeneficiarioTbl" + docOwner.id}
                 title={"Documentos del Beneficiario " +
                 DocumentosUtils.generarNombrePropietario(docOwner.propietario)}
                 totalDocs={generarTotalDocs(docOwner, totalDocsBeneficiario)}
                 pendingDocs={
                   (generarTotalDocs(docOwner, totalDocsBeneficiario) -
                     generarTotalDocs(docOwner, pendingDocsBeneficiario))}>
            {docsBeneficiario
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </Table>
            )}

        {(docsReclamante.length > 0 && docsReclamantesPropietarios.length > 0) &&
        docsReclamantesPropietarios.map(docOwner =>
          <Table key={docOwner.id}
                 id={"edDocsReclamanteTbl" + docOwner.id}
                 title={"Documentos del Reclamante " +
                 DocumentosUtils.generarNombrePropietario(docOwner.propietario)}
                 totalDocs={generarTotalDocs(docOwner, totalDocsReclamante)}
                 pendingDocs={
                   (generarTotalDocs(docOwner, totalDocsReclamante) -
                     generarTotalDocs(docOwner, pendingDocsReclamante))}>
            {docsReclamante
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </Table>
        )}

        {(docsCurador.length > 0 && docsCuradoresPropietarios.length > 0) &&
        docsCuradoresPropietarios.map(docOwner =>
          <Table key={docOwner.id}
                 id={"edDocsCuradorTbl" + docOwner.id}
                 title={"Documentos del Curador " +
                 DocumentosUtils.generarNombrePropietario(docOwner.propietario)}
                 totalDocs={generarTotalDocs(docOwner, totalDocsCurador)}
                 pendingDocs={
                   (generarTotalDocs(docOwner, totalDocsCurador) -
                     generarTotalDocs(docOwner, pendingDocsCurador))}>
            {docsCurador
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </Table>
        )}

        {(docsApoderado.length > 0 && docsApoderadosPropietarios.length > 0) &&
        docsApoderadosPropietarios.map(docOwner =>
          <Table key={docOwner.id}
                 id={"edDocsApoderadoTbl" + docOwner.id}
                 title={"Documentos del Apoderado " +
                 DocumentosUtils.generarNombrePropietario(docOwner.propietario)}
                 totalDocs={generarTotalDocs(docOwner, totalDocsApoderado)}
                 pendingDocs={
                   (generarTotalDocs(docOwner, totalDocsApoderado) -
                     generarTotalDocs(docOwner, pendingDocsApoderado))}>
            {docsApoderado
              .filter(doc => doc.propietario.identificacion.numero === docOwner.id)
              .map(doc => generarFilaDocumento(doc, values, form.mutators, false))}
          </Table>
        )}

        {formatos.length > 0 &&
        <Table id="edFormatosTbl"
               title="Formatos"
               totalDocs={totalFormatos}
               pendingDocs={pendingFormatos}>
          {formatos.map(doc => generarFilaDocumento(doc, values, form.mutators, true))}
        </Table>
        }

        {(disabled && showAlert) &&
        <div className={styles.MensajeDocumentosPendientes}>
          <img id="edAlertaDocumentosImg" src={require("../../assets/img/icons/alert-circle.svg")}
               alt="Alerta"/>
          <p>Para poder finalizar debes adjuntar los documentos correspondientes.</p>
        </div>
        }

        <div className="row justify-content-center">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
            <div className={styles.FooterButtonContainer}>
              <Button
                id="edVolverBtn"
                name="edVolverBtn"
                type="button"
                typeStyle="ghost"
                height="48"
                onClick={handleGoBack}
              >
                Volver
              </Button>
            </div>
          </div>
          {showButton &&
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
            <div className={styles.FooterButtonContainer}>
              <Button cssClassName={styles.BtnEnviar}
                      id="edEnviarBtn"
                      name="edEnviarBtn"
                      type="submit"
                      typeStyle="primary"
                      height="48"
                      loader={loader}
                      disabled={disabled}>
                Enviar documentos
              </Button>
            </div>
          </div>
          }
        </div>

      </form>
    </>
  );

};

const generarTotalDocs = (owner, docs) => {
  return docs.filter(doc => owner.id === doc.propietario.identificacion.numero).length;
};

export default EstadoDocumentosForm;
